import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import TopBar from '../topbar/topbar'
import { BASE } from '../api/api'
import Axios from 'axios'
import cachios from 'cachios'
import { List } from 'react-content-loader'
import sample from '../assets/Article.png'
import search from '../assets/search.png'
import htmlToText from 'html-to-text'
import Highlighter from "react-highlight-words";
import { getName } from 'country-list'
import ReactHtmlParser from 'react-html-parser';

class Periodicals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      people: '',
      bioimage: '',
      limit: 10,
      offset: props.match.params.page ? parseInt(props.match.params.page, 10) : 0,
      next: false,
      prev: false,
      search: props.match.params.key ? props.match.params.key : '',
      lang: props.match.params.type ? props.match.params.type : 'English',
      imagearray: []
    }
  }

  settype(lang) {
    this.setState({
      offset: 0,
      search: ''
    })
    this.props.history.push('/periodicals/' + lang + '/0')
  }

  pagestore(id) {
    localStorage.setItem('pagenumper', JSON.stringify(id))
  }

  searchclick() {
    this.setState({
      offset: 0
    })
    if (this.state.search) {
      this.props.history.push('/periodicals/' + this.state.lang + '/0/' + this.state.search)
    }
    else {
      this.props.history.push('/periodicals/' + this.state.lang + '/0')
    }

  }

  _handleKeyPress(e) {

    if (e.key === 'Enter') {
      // this.apicall(this.state.offset, this.state.search, this.state.lang)
      this.setState({
        offset: 0
      })
      if (this.state.search) {
        this.props.history.push('/periodicals/' + this.state.lang + '/0/' + this.state.search)
      }
      else {
        this.props.history.push('/periodicals/' + this.state.lang + '/0')
      }
    }
  }


  handlePageClick = data => {
    console.log(data, 'offset')
    let dt = localStorage.getItem('token');

    if (data === 'next' && this.state.next === true) {
      this.redirnext()
      if (dt && dt != null) {
        this.checkexpiry()
        this.setState({
          people: '',
        })
        let page = this.state.offset + 1
        console.log("number", parseInt(this.state.offset + this.state.limit, 10) / this.state.limit)
        if (this.state.search)
          this.props.history.push('/periodicals/' + this.state.lang + '/' + page + '/' + this.state.search)
        else
          this.props.history.push('/periodicals/' + this.state.lang + '/' + page)
        this.setState({
          offset: this.state.offset + 1
        })

      }

    }
    else if (data === 'prev' && this.state.prev === true) {
      this.setState({
        people: '',
      })
      let page = this.state.offset - 1
      console.log("number", parseInt(this.state.offset - this.state.limit, 10))

      if (this.state.search)
        this.props.history.push('/periodicals/' + this.state.lang + '/' + page + '/' + this.state.search)
      else
        this.props.history.push('/periodicals/' + this.state.lang + '/' + page)
      this.setState({
        offset: this.state.offset - 1
      })

    }
  }
  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  signout() {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    if (this.state.search)
      this.props.history.push('/login?redir=/periodicals/' + this.state.lang + '/' + this.state.offset + '/' + this.state.search)
    else
      this.props.history.push('/login?redir=/periodicals/' + this.state.lang + '/' + this.state.offset)
  }


  refreshexp() {
    let s = new Date();
    s.setSeconds(s.getSeconds() + 1800);
    localStorage.setItem('expiryref', s)
  }


  checkexpiry() {
    if (localStorage.getItem('expiryref')) {
      let expref = Date.parse(localStorage.getItem('expiryref'))
      let s = new Date();
      if (s > expref) {
        this.signout()
      }
      else {
        this.refreshexp()
      }

    }
    else {
      this.signout()

    }
  }

  // componentWillMount(){
  //   if(this.state.token)
  //       this.checkexpiry()
  // }

  componentWillMount() {
    let login = localStorage.getItem('token');

    if (this.state.offset !== 0 && !this.logincheck()) {
      if (this.state.search)
        this.props.history.push('/login?redir=/periodicals/' + this.state.lang + '/' + this.state.offset + '/' + this.state.search)
      else
        this.props.history.push('/login?redir=/periodicals/' + this.state.lang + '/' + this.state.offset)
    }
    else if (login && login != null) {
      this.checkexpiry()
    }

    let page = parseInt(this.state.offset, 10) * parseInt(this.state.limit, 10)
    this.apicall(page, this.state.search, this.state.lang)
    localStorage.removeItem('period_ret');
  }

  pagestore(id) {

    localStorage.setItem('pagenumper', JSON.stringify(id))

  }
  componentWillReceiveProps(nextProps) {
    let dt = localStorage.getItem('token');
    if (dt && dt != null) {
      this.setState({
        login: true
      })
    }
    else {
      this.setState({
        login: false
      })
    }
    this.setState({
      people: '',
      lang: nextProps.match.params.type,
      search: nextProps.match.params.key ? nextProps.match.params.key : ''
    })
    let offset = parseInt(nextProps.match.params.page, 10) * this.state.limit
    console.log("numb", offset)
    if (nextProps.match.params.key) {
      this.apicall(offset, nextProps.match.params.key, nextProps.match.params.type)
    }
    else
      this.apicall(offset, '', nextProps.match.params.type)
  }



  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
    if (!this.logincheck) {
      this.props.history.push('/login?redir=/periodicals/' + this.state.lang + '/0')
    }
    if (e.target.value === '') {
      this.setState({
        offset: 0
      })
      this.props.history.push('/periodicals/' + this.state.lang + '/0')

    }
  }
  redirnext() {
    let login = localStorage.getItem('token');
    if (login && login != null) {
      return true
    }
    else {
      this.props.history.push('/login?redir=/periodicals/' + this.state.lang + '/1')
    }
  }

  apicall(id, contains, lang) {
    let page = parseInt(id, 10) * parseInt(this.state.limit, 10)
    console.log("numb", parseInt(id, 10), parseInt(this.state.limit, 10), page)

    if (contains) {
      let login = localStorage.getItem('token');
      if (!login || login === null) {
        this.props.history.push('/login?redir=/periodicals/' + this.state.lang + '/' + this.state.offset + '/' + contains)
      }
    }
    this.setState({
      people: ''
    })
    this.topFunction();
    if (id <= 0) {
      this.setState({
        prev: false,
      })
    }
    else {
      this.setState({
        prev: true
      })
    }

    //to check Next page
    Axios(BASE + 'jsonapi/node/periodicals?sort=title&filter[langcode][condition][path]=field_language&filter[langcode][condition][value]=' + lang + '&filter[title][condition][path]=title&filter[title][condition][operator]=CONTAINS&filter[title][condition][value]=' + contains.replace(/^\s+/g, '') + '&page[limit]=' + this.state.limit + '&page[offset]=' + (id + this.state.limit), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then((data) => {
        console.log(data.data, 'next')
        //HIDE/SHOW  NEXT button
        if (data.data.data.length === 0) {
          this.setState({
            next: false,
          })
        }
        else {
          this.setState({
            next: true
          })
        }
      })


    cachios.get(BASE + 'jsonapi/node/periodicals?sort=title&include=field_image&filter[langcode][condition][path]=field_language&filter[langcode][condition][value]=' + lang + '&filter[title][condition][path]=title&filter[title][condition][operator]=CONTAINS&filter[title][condition][value]=' + contains.replace(/^\s+/g, '') + '&page[limit]=' + this.state.limit + '&page[offset]=' + id, {
      ttl: 500 /* seconds */,
    })
      // .then((data) => {
      //   console.log(data, 'url')
      //   if (data.data.data.length === 0) {
      //     this.apicall(this.state.offset, '', this.state.lang)
      //     this.setState({
      //       offset: 0
      //     })
      //   }
      //   this.setState({
      //     people: data.data.data,
      //   })
      // })
      // .catch((err) => {
      //   console.log('not found')
      // })

      .then((data) => {
        if (data.data.data.length === 0) {
          // this.apicall(this.state.offset, '', this.state.lang)
          // alert('No Results Found')
          this.fillalert()
          this.setState({
            people: []
          })
          // this.props.history.push('/periodicals/'+this.state.lang)
          this.setState({
            offset: 0
          })
        }
        this.setState({
          people: data.data.data,

        })
        this.topFunction();

        let i, j;
        let imagearray = []
        for (i = 0; i < data.data.data.length; i++) {
          if (data.data.data[i].relationships.field_image.data !== null) {
            for (j = 0; j < data.data.included.length; j++) {
              if (data.data.data[i].relationships.field_image.data.id === data.data.included[j].id) {
                imagearray.push(BASE + data.data.included[j].attributes.uri.url);
              }
            }
          }
          else {
            imagearray.push(sample)
          }
        }
        this.setState({
          imagearray: imagearray
        })
        console.log(imagearray)
      })
      .catch(error => console.log(error));

  }

  fillalert() {
    this.setState({
      fillalert: true
    })
    setTimeout(
      function () {
        this.setState({
          fillalert: null
        })
      }
        .bind(this),
      3000
    );
  }

  logincheck() {
    let login = localStorage.getItem('token');
    if (login && login != null) {
      this.checkexpiry()
      return true
    }
    else
      return false
  }

  link(link) {
    if (this.logincheck())
      return link
    else
      return '/login?redir=' + link
  }


  gethighlight(data) {
    let words = this.state.search && this.props.match.params.key ? this.state.search.split(" ") : []
    return <Highlighter
      highlightClassName="YourHighlightClass"
      searchWords={words}
      autoEscape={true}
      textToHighlight={data}
    />
  }

  render() {
    console.log(this.state.offset)
    return (
      <div className='biopage periopage cispub periodics'>
        {this.state.fillalert ? <div className="fill-alert">No Results Found for <span id="noword">{this.state.search}</span></div> : ''}

        <Header />
        <div className='container'>
          <div className='listings'>
            <div className='top-contents'>
              <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/periodicals/English/0'>Islamic Finance Periodicals</Link></div>
             
            </div>
            <div className="">
              <div className="tabsection">
                <button style={{ backgroundColor: this.state.lang === 'English' ? '#165E84' : '' }} onClick={() => this.settype('English')}>English</button>
                <button style={{ backgroundColor: this.state.lang === 'Arabic' ? '#165E84' : '' }} onClick={() => this.settype('Arabic')}>العربية</button>
              </div>
            </div>
            <div className="page-people" >
              <div className="page-title">
                <div className="title-wrapper">
                  <div className=" gloss_container">
                    <div>
                      <h1 className="heading">Islamic Finance Periodicals</h1>
                    </div>
                    <div className="search_input" style={{ alignSelf: 'center', zIndex: this.state.inputhide == true ? -1 : 0 }}>

                      <input type="text" placeholder="Search" value={this.state.search} name="search" onChange={e => { this.handleChange(e) }} onKeyPress={(e) => this._handleKeyPress(e)} maxLength={50} />
                      <div className="search_logo"><img onClick={() => this.searchclick()} src={search} height="20px" /></div>
                      {/* </form> */}
                    </div>
                  </div>

                </div>
              </div>

              <div className="main-content">
                <div className="">
                  <div className="row">
                    <div className="region region-content">
                      <div className="listings">
                        {this.state.people ? this.state.people.length !== 0 && this.state.imagearray.length !== 0 ?
                          <div className="mission">
                            {this.state.people.map((people, index) => {
                              return (
                                <div>
                                  <div className="title">
                                    <span className="field-content bookdiv">
                                      <div>
                                        <Link onClick={() => this.pagestore(this.state.offset)} to={this.link('/periodicals_desc/' + `${people.attributes.drupal_internal__nid}`)}>
                                          <img src={this.state.imagearray[index]} />
                                        </Link>
                                      </div>
                                      <div className="bookdetails">
                                        <Link onClick={() => this.pagestore(this.state.offset)} to={this.link('/periodicals_desc/' + `${people.attributes.drupal_internal__nid}`)}>{this.gethighlight(people.attributes.title)}</Link>
                                        {/* {people.attributes.body ? <div>
                                      {htmlToText.fromString(people.attributes.body.processed, {
                                        wordwrap: 130
                                      }).length > 120 ? htmlToText.fromString(people.attributes.body.processed, {
                                        wordwrap: 130
                                      }).substring(0, 120) + '...' : htmlToText.fromString(people.attributes.body.processed, {
                                        wordwrap: 130
                                      })}
                                    </div> : ''} */}
                                        {/* {people.attributes.body ? 
                                     <div>
                                      {htmlToText.fromString(people.attributes.body.processed.split("</p>")[0])}
                                    </div> : ''}
                                    */}
                                        {people.attributes.body ? <div className='publisher'>
                                          {ReactHtmlParser(people.attributes.body.processed.split("</p>")[0])}
                                        </div> : ''}
                                        {people.attributes.field_country ?
                                          <div>
                                            <p>Country: {getName(people.attributes.field_country)}</p>
                                          </div> : ''}

                                        {/* {people.attributes.field_isbn ?
                                                                                <div>
                                                                                    ISBN:{people.attributes.field_isbn}
                                                                                </div> : ''}
                                                                            <div>
                                                                                Year:{people.attributes.field_year}
                                                                            </div> */}
                                      </div>

                                    </span>
                                  </div>

                                </div>
                              )
                            })}

                          </div> :
                          <div>
                            <div className="title">
                              <span className="noalert field-content bookdiv">
                                <div>
                                  No Results Found for <span id="noword">{this.state.search}</span>
                                </div>

                              </span>
                            </div>

                          </div> : <List />

                        }


                      </div>
                    </div>


                  </div>
                </div>
              </div>

              {/* <div className="main-content listing">
            <div className="container ">
              <div className="row">
                <div className="region region-content">
                  <div className="listings">

                    {this.state.people ?
                      this.state.people.map((people, index) => {
                        return (
                          <div className="title">

                            <span className="field-content">
                              <Link onClick={() => this.pagestore(this.state.offset)} to={this.link('/periodicals_desc/' + `${people.attributes.drupal_internal__nid}`)}>{people.attributes.title}</Link>
                            </span>

                          </div>
                        )
                      }) : <List />

                    }

                  </div>
                </div>
              </div>
            </div>
          </div> */}

            </div>

            {this.state.people ? this.state.prev || this.state.next ?

              <ul className="pagination">
                <li onClick={() => this.handlePageClick('prev')} className="previous disabled">
                  <a style={{ color: this.state.prev ? '#165E84 ' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.prev ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
                <li onClick={() => this.handlePageClick('next')} className="next"><a style={{ color: this.state.next ? '#165E84 ' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>

              </ul>

              : '' : ''}
          </div>
        </div>
        <div>
          <Footer />
        </div>
      </div>
    )


  }

}

export default Periodicals;
